import { Col, Row } from 'reactstrap';
import React from 'react';
import { useSelector } from 'react-redux';
import { getUserPaymentDetails } from 'redux/query';

export const SubscriptionDetailAboState = () => {
  const { active } = useSelector(getUserPaymentDetails);

  return (
    <Row className="mt-2">
      <Col xs={12} sm={6} className="subscription-status-title">
        <strong>Status</strong>
      </Col>
      <Col xs={12} sm={6}>
        {active && 'Aktiv'}
      </Col>
    </Row>
  );
};
